module.exports = __webpack_public_path__ + "static/img/app_share_shipper-app-logo.121ab1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/app_share_shipper-app-logo.png
// module id = qD0H
// module chunks = 1